<template lang="html">
  <div id="text-page">
    <div class="container med-container">
      <div class="col-12 col-s-title">
        <h1 class="title"><span>Código de políticas de gestión de tráfico y administración de red</span></h1>
      </div>

      <div class="body">
      </div>

    </div>
  </div>
</template>

<script>
export default {
}
</script>
